import React from 'react'
import Planning from '../img/Planning/Planning 8.jpg';
import Kitchen from '../img/Kitchen/kitchen 1.jpg';
import Elevation from '../img/Elevation/Elevation.jpg';
import Electrical from '../img/Electrical/Electrical 1.jpg';
import Interior from '../img/Kitchen/Kitchen 4.jpg';
import Door from '../img/Door Window/Door Window 1.jpg';
import LANDSCAPE from '../img/LANDSCAPE.jpg';
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Link } from "react-router-dom";


function Services() {

    return (
        <section id="section1" style={{ margin: "30px 0" }}>
            <div className="projects">
                <h2>Our Services</h2>
            </div>
            <div className="cont1">
                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Planning} alt="Rk Designs" />
                        <div className="details">
                            <p id="Planning" className="vis"><Link to='/planning'> Planning</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>

                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Kitchen} alt="Rk Designs" />
                        <div className="details">
                            <p id="Kitchen" className="vis"><Link to='/kitchen'>Modular Kitchen</Link></p>
                        </div>
                    </div>\
                </AnimationOnScroll>

                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Elevation} alt="Rk Designs" />
                        <div className="details">
                            <p id="Elevation" className="vis"><Link to='/elevation'>Front Elevation</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Electrical} alt="Rk Designs" />
                        <div className="details">
                            <p id="Electrical" className="vis"><Link to='/electrical'>Electrical Drawing</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Interior} alt="Rk Designs" />
                        <div className="details">
                            <p id="Interior" className="vis"><Link to='/interior'>Interior Designing</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={Door} alt="Rk Designs" />
                        <div className="details">
                            <p id="Door" className="vis"><Link to='/door'>Door Window Designs</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>
                <AnimationOnScroll animateIn='slipeLeft'>
                    <div className="Workimage">
                        <img className="img" src={LANDSCAPE} alt="Rk Designs" />
                        <div className="details">
                            <p id="Landscape" className="vis"><Link to='/landscape'>Landscape Designs</Link></p>
                        </div>
                    </div>
                </AnimationOnScroll>


            </div>
        </section>
    )
}

export default Services
